// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/article',
    name: 'ArticleManage',
    component: layout,
    redirect: '/article/index',
    meta: {
      title: '文章管理',
      roles: [0]
    },
    sort: 3,
    children: [
      {
        path: 'index',
        name: 'ArticleManageIndex',
        component: () => import('@/views/Manage/Article.vue'),
        meta: {
          title: '文章列表',
          icon: 'i-tabler:article',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
